/* eslint-disable */
import React from 'react'

import capitalize from 'utils/capitalize'

import {
  AddCoProposerDropdownMenuWrapper,
  AddCoProposerMenuItem,
  AddCoProposerMenuItemEmail,
  AddCoProposerMenuItemIcon,
  AddCoProposerMenuItemName
} from '../style'

const PotentialCoProposerMenuList = ({ list, onSelect }) => {

  if (!list.length) {
    return null
  }

  return (
    <AddCoProposerDropdownMenuWrapper>
      {list.map((option) => {
        return (
          <AddCoProposerMenuItem
            key={option.id}
            onClick={() => {
              onSelect(option)
            }}
          >
            <AddCoProposerMenuItemIcon />
            <div>
              <AddCoProposerMenuItemName>{`${capitalize(option.lastName)}   ${capitalize(option.firstName)}`}</AddCoProposerMenuItemName>
              <AddCoProposerMenuItemEmail>{option.email}</AddCoProposerMenuItemEmail>
            </div>
          </AddCoProposerMenuItem>
        )
      })}
    </AddCoProposerDropdownMenuWrapper>
  )
}

export default PotentialCoProposerMenuList
